import React, { Component } from 'react';
import { connect } from 'react-redux';

import LoginForm from './LoginForm/LoginForm';
import Board from './Board/Board';
import * as actions from '@store/actions';
import Helmet from 'react-helmet';

class Quoting extends Component {
  constructor(props) {
    super(props);
    props.reload();
  }
  render() {
    const isMobile = this.props.pageWidth < 992;
    return (
      <div
        className={isMobile ? '' : 'w-100 position-relative'}
        style={isMobile ? {} : { overflowX: 'hidden' }}
      >
        <Helmet>
          <title>My Account | JetSuite</title>
          <meta
            name="description"
            content={'Login to your JetSuite account.'}
          />
        </Helmet>
        {!this.props.isAuthenticated ? (
          <LoginForm id={'quoting-login'} {...this.props} />
        ) : (
          <Board id={'quoting-board'} {...this.props} />
        )}
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.token !== null
  };
};

const mapDispatchToProps = dispatch => {
  return {
    reload: () => dispatch(actions.quotingReload())
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Quoting);



// WEBPACK FOOTER //
// ./src/components/Quoting/Quoting.jsx